import { Chip, TableCell, TableRow, Typography } from "@mui/material";

import { Div } from "themes/jumbo/@jumbo/shared";
import { PendingType } from "./types";
import { getCachedData } from "api/Cache";
import { tss } from "tss-react";
import { ReactComponent as File } from "assets/images/file.svg";
import { icons } from "constants/viewer";
import * as Utils from "services/UtilsService";

const useStyles = tss.create(() => ({
  ellipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box"
  },
  multiLineEllipsis: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical"
  },
  tableTr: {
    " &:hover": {
      background: 'rgba(0, 0, 0, .05)',
      //cursor: 'pointer'
    }
  },
  tableTd: {
    padding: '8px 16px',
    fontSize: '0.813rem',
    " &.fixedHeight": {
      height: '57px'
    }
  },
  icon: {
    width: 27,
    height: 27,
    marginRight: 10,
    color: 'rgb(0,0,0,0.53)',
  },
  layerIcon: {
    display: "inline-flex",
    alignItems: "center",
  },
}));

const getIcon = (fileName: string, classes: any) => {
  if (!fileName) {
      return <File className={classes.icon} />;
  }
  const Icon = icons[fileName];
  return (
      <div className={classes.layerIcon}>
          <Icon className={classes.icon} />
      </div>
  );
}

const PendingItem = ({ item, index }: { item: PendingType, index: Number }) => {

  const { classes } = useStyles();
  //const { ID:projectID, name:projectName = 'Unknown Project', description:projectDescription = '', image = '', thumbnail = '', timezone } = item;
  const projects: any = getCachedData("projects");

  return (
    <TableRow
      sx={{
        "td:first-of-type": {
          pl: 3,
        },
        "td:last-child": {
          pr: 3,
        },
      }}
      className={classes.tableTr}
    >
      <TableCell  className={`${classes.tableTd} fixedHeight`}>
        <Div sx={{ display: "flex", minWidth: 0, alignItems: "center" }}>
          {getIcon(item.fileName, classes)}
          <Typography variant="h5" mb={0.5} fontSize={14} className={classes.multiLineEllipsis}>
            {item.name}
          </Typography>
        </Div>
      </TableCell>
      <TableCell className={classes.tableTd}>
        <Div sx={{ display: "flex", flexDirection: "column", alignItems: "center"  }}>
          <Typography 
            variant={'body1'} 
            sx={{ fontSize: '12px !important' }} 
            color={'text.secondary'} 
            textAlign={'center'} 
          >
            {Utils.formatDateWithTime(item.date)}
          </Typography>
        </Div>
      </TableCell>
    </TableRow>
  );
};

const EmptyPendingItem = () => {

  const { classes } = useStyles();

  return (
    <TableRow
      sx={{
        "td:first-of-type": {
          pl: 3,
        },
        "td:last-child": {
          pr: 3,
        },
      }}
    >
      <TableCell colSpan={2}>
      <Typography
          fontSize={'13px'}
          variant={'body1'}
          color={'text.secondary'}
          sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '50px 0', height: '323px'}}
      >
          No pending process
      </Typography>
      </TableCell>
    </TableRow>
  );
};
export { PendingItem, EmptyPendingItem };
